import React, { useMemo } from 'react';

import { useSelector } from "../../../../../util/store/store";
import { CALENDAR_ID, selectPlan } from "../../../constants";
import AvailableTimes from "../AvailableTimes";
import Contracts from "../Contracts";
import LazyLoading from "../LazyLoading";
import Operations from "../Operations";
import { calculateWidth } from "../constants";
import EmptyVessels from "./EmptyVessels";
import Layout from "./Layout";
import Vessel from "./Vessel";
import VesselName from "./VesselName";

const Vessels: React.FC = React.memo((props) => {
    const level = useSelector(selectPlan.level);
    const vessels = useSelector(selectPlan.vessels);

    const { show, width, maxWidth } = useMemo(() => {
        const { data, count } = vessels.reduce((rs: { data: { [id: string]: number }, count: number }, { id, isShow }) => {
            if (isShow) {
                rs.data[id] = rs.count;
                rs.count++
            }
            return rs;
        }, { data: {}, count: 0 });

        const width = calculateWidth(count);
        return { show: data, width, maxWidth: width * Object.keys(data).length }
    }, [vessels])

    const count = vessels.length;
    if (count === 0)
        return <EmptyVessels />;

    return <    >
        <Layout calendarWidth={maxWidth} />
        {
            (width ? vessels : []).map(vessel => {
                const { id: vesselId, contracts, available_times } = vessel;

                return <Vessel
                    key={vesselId}
                    width={width}
                    index={show[vesselId]}
                    vessel={vessel}
                    calendarId={CALENDAR_ID}
                >
                    <Operations
                        width={width}
                        vesselIndex={show[vesselId]}
                        level={level[vesselId]}
                    />
                    <AvailableTimes
                        width={width}
                        vesselIndex={show[vesselId]}
                        available_times={available_times}
                        vessel={vessel}
                    />
                    <Contracts
                        width={width}
                        vesselIndex={show[vesselId]}
                        contracts={contracts}
                        vessel={vessel}
                    />
                    <VesselName vessel={vessel} />
                </Vessel>
            })
        }
        <LazyLoading calendarWidth={maxWidth} />
    </>
});

export default Vessels;